/* toki-sponsored-wheel.part3.js — SVG wheel renderer */
(function(){
  'use strict';
  var W=window.TokiSponsoredWheelEngine;
  if(!W||W.__part3Loaded) return;
  W.__part3Loaded=true;
  var NS='http://www.w3.org/2000/svg', XL='http://www.w3.org/1999/xlink', TAU=Math.PI*2;

  function polar(cx,cy,r,a){ return {x:cx+r*Math.cos(a),y:cy+r*Math.sin(a)}; }
  function wedge(cx,cy,r0,r1,a0,a1){
    var p0=polar(cx,cy,r1,a0),p1=polar(cx,cy,r1,a1),p2=polar(cx,cy,r0,a1),p3=polar(cx,cy,r0,a0);
    return ['M',p0.x,p0.y,'A',r1,r1,0,0,1,p1.x,p1.y,'L',p2.x,p2.y,'A',r0,r0,0,0,0,p3.x,p3.y,'Z'].join(' ');
  }
  function add(tag,attrs,parent){
    var n=document.createElementNS(NS,tag);
    Object.keys(attrs||{}).forEach(function(k){ n.setAttribute(k,attrs[k]); });
    if(parent) parent.appendChild(n);
    return n;
  }

  W.renderWheel=function(inst){
    var r=inst.refs, svg=r.svg, segs=inst.cfg.segments;
    while(svg.firstChild) svg.removeChild(svg.firstChild);
    var cx=500,cy=500,outer=462,inner=126,n=segs.length,step=TAU/n,start=-Math.PI-step/2;

    var defs=add('defs',{},svg);
    var shadow=add('filter',{id:'ggwShadow',x:'-40%',y:'-40%',width:'180%',height:'180%'},defs);
    add('feDropShadow',{dx:'0',dy:'18',stdDeviation:'15','flood-color':'#000','flood-opacity':'.38'},shadow);
    var glow=add('filter',{id:'ggwGlow',x:'-60%',y:'-60%',width:'220%',height:'220%'},defs);
    add('feDropShadow',{dx:'0',dy:'0',stdDeviation:'18','flood-color':'#56A99A','flood-opacity':'.82'},glow);
    var clip=add('clipPath',{id:'ggwClip'},defs); add('circle',{cx:cx,cy:cy,r:outer},clip);

    r.wheelGroup=add('g',{class:'ggw-wheelGroup',transform:'rotate(0 500 500)'},svg);
    add('circle',{cx:cx,cy:cy,r:outer+14,fill:'#160f0b',stroke:'#DEA564','stroke-width':'8',filter:'url(#ggwShadow)'},r.wheelGroup);
    var clipped=add('g',{'clip-path':'url(#ggwClip)'},r.wheelGroup);
    r.sliceNodes=[]; r.sliceVecs=[];

    segs.forEach(function(s,i){
      var a0=start+i*step,a1=a0+step,mid=(a0+a1)/2,v={x:Math.cos(mid),y:Math.sin(mid)};
      var sg=add('g',{class:'ggw-slice','data-ggw-idx':i},clipped);
      r.sliceNodes.push(sg); r.sliceVecs.push(v);
      add('path',{d:wedge(cx,cy,inner,outer,a0,a1),fill:s.color},sg);
      add('path',{d:wedge(cx,cy,inner,outer,a0,a1),fill:'none',stroke:'#fff','stroke-opacity':'.16','stroke-width':'3'},sg);
      add('path',{d:wedge(cx,cy,inner,outer,a0,a1),fill:'none',stroke:'#000','stroke-opacity':'.18','stroke-width':'5'},sg);
      var p=polar(cx,cy,310,mid), stickerSize=144, img=add('image',{x:p.x-stickerSize/2,y:p.y-stickerSize/2,width:stickerSize,height:stickerSize,preserveAspectRatio:'xMidYMid meet'},sg);
      img.setAttributeNS(XL,'xlink:href',s.img); img.setAttribute('href',s.img);
    });

    add('circle',{cx:cx,cy:cy,r:inner+8,fill:'#18100c',stroke:'#56A99A','stroke-width':'8',filter:'url(#ggwGlow)'},clipped);
    r.centerGroup=add('g',{class:'ggw-centerSpin'},clipped);
    var c=add('image',{x:362,y:362,width:276,height:276,preserveAspectRatio:'xMidYMid meet'},r.centerGroup);
    c.setAttributeNS(XL,'xlink:href',inst.cfg.centerUrl); c.setAttribute('href',inst.cfg.centerUrl);
    W.setWheelDeg(inst,0);
  };

  W.pointerIndexForDeg=function(inst,deg){
    var n=inst.cfg.segments.length, step=360/n;
    var startDeg=-180-step/2;
    var localTop=W.util.normDeg(-90-deg);
    var rel=W.util.normDeg(localTop-startDeg);
    return Math.floor(rel/step)%n;
  };

  W.updatePointerColor=function(inst,deg){
    if(!inst.refs.pointer) return;
    var idx=W.pointerIndexForDeg(inst,deg);
    var seg=inst.cfg.segments[idx];
    if(seg) inst.refs.pointer.style.setProperty('--ggw-pointer-color',seg.color);
  };

  function isAppleWebKit(){
    try{
      var ua=navigator.userAgent||'';
      var appleDevice=/iPad|iPhone|iPod/.test(ua)||(ua.indexOf('Macintosh')>=0&&('ontouchend' in document));
      var safari=/Safari/.test(ua)&&!/Chrome|CriOS|Edg|OPR|Firefox|FxiOS/.test(ua);
      return appleDevice||safari;
    }catch(_){ return false; }
  }

  W.setWheelDeg=function(inst,deg){
    inst.rt.wheelDeg=deg;
    var g=inst.refs.wheelGroup, svg=inst.refs.svg;

    if(typeof inst.rt.applePerf==='undefined'){
      inst.rt.applePerf=isAppleWebKit();
      if(inst.rt.applePerf&&inst.host) inst.host.classList.add('ggw-applePerf');
    }

    // Safari/iOS performance path: rotate the complete SVG as one compositor layer.
    // This avoids recalculating every SVG path on every animation frame.
    if(inst.rt.applePerf&&svg){
      if(g){
        g.removeAttribute('transform');
        g.style.transform='';
      }
      svg.style.transformOrigin='50% 50%';
      svg.style.webkitTransformOrigin='50% 50%';
      svg.style.willChange='transform';
      svg.style.transform='translateZ(0) rotate('+deg+'deg)';
      svg.style.webkitTransform='translateZ(0) rotate('+deg+'deg)';
    }else if(g){
      if(svg){
        svg.style.transform='';
        svg.style.webkitTransform='';
        svg.style.willChange='';
      }
      g.setAttribute('transform','rotate('+deg+' 500 500)');
    }

    W.updatePointerColor(inst,deg);
  };
})();
